export default "__VITE_ASSET__d7cca3eb__"